import { render, staticRenderFns } from "./LivingPlace.vue?vue&type=template&id=01654778&scoped=true&"
import script from "./LivingPlace.vue?vue&type=script&lang=tsx&"
export * from "./LivingPlace.vue?vue&type=script&lang=tsx&"
import style0 from "./LivingPlace.vue?vue&type=style&index=0&id=01654778&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01654778",
  null
  
)

export default component.exports